/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  const jsonElement = $("#custom-configurator-json");
  const fullData = JSON.parse(jsonElement.html());
  let lengthValue;
  let widthValue;

  const getAvailableWidths = (productsArray) => {
    const widthArray = [];

    productsArray.forEach((product) => {
      let elementsWithWidth = $(".js-widths-available");
      let width;
      elementsWithWidth.each(function (_, el) {
        if ($(el).attr("data-product-id") == product.id) {
          width = $(el).attr("id");
        }
      });

      const stringArray = width.split("-");
      const productWidth = stringArray[1];
      widthArray.push(parseInt(productWidth));
    });

    widthArray.sort(function (a, b) {
      return a - b;
    });
    const fullWidthArray = [];
    for (let i = widthArray[0]; i <= widthArray[widthArray.length - 1]; i++) {
      fullWidthArray.push(i);
    }

    return { widthArray, fullWidthArray };
  };

  const getAvailableLengths = (data) => {
    const lengthArray = [];
    data.forEach((product) => {
      const productLength = product.options[0];
      if (!lengthArray.includes(parseInt(productLength))) {
        lengthArray.push(parseInt(productLength));
      }
    });
    lengthArray.sort(function (a, b) {
      return a - b;
    });
    const fullLengthArray = [];
    for (
      let i = lengthArray[0];
      i <= lengthArray[lengthArray.length - 1];
      i++
    ) {
      fullLengthArray.push(i);
    }
    return { lengthArray, fullLengthArray };
  };

  const getClosestHigherLength = (selectedLength, availablelengths) => {
    if (availablelengths.includes(parseInt(selectedLength))) {
      return selectedLength;
    } else {
      let lengthToUse;
      for (let index = 0; index < availablelengths.length; index++) {
        if (
          selectedLength > availablelengths[index] &&
          selectedLength < availablelengths[index + 1]
        ) {
          lengthToUse = availablelengths[index + 1];
        }
      }
      return lengthToUse.toString();
    }
  };

  const getProductByOptions = (
    allProducts,
    width,
    availableWidths,
    selectedLength,
    availablelengths,
    cassette
  ) => {
    const cassetteOptionsToCheck = ["none", "arc", "square"];
    let cassetteOption;

    cassetteOptionsToCheck.forEach((el) => {
      if (cassette.toLowerCase().includes(el)) {
        cassetteOption = el;
      }
    });
    let isCordless = "No";
    if (
      $("#custom-configurator-option-lift").attr("data-image-select-value") ==
      "Cordless"
    ) {
      isCordless = "Yes";
    }
    const widthToCheck = getClosestHigherLength(width, availableWidths);
    const productId = $(`#width-${widthToCheck}`).attr("data-product-id");
    const mainProduct = allProducts.find((e) => e.id == productId);
    const lengthToCheck = getClosestHigherLength(
      selectedLength,
      availablelengths
    );
    const productVariant = mainProduct.variants.find((e) => {
      return (
        e.options[0] == lengthToCheck.toString() &&
        e.options[1].toLowerCase() == cassetteOption &&
        e.options[2] == isCordless
      );
    });

    return productVariant;
  };

  const createSelectOptions = (data, selectId) => {
    const selectElement = $(`#${selectId}`);
    data.forEach((option, index) => {
      let singleElement = `<option value="${option}">${option}</option>`;
      if (index == 0) {
        singleElement = `<option value="${option}" selected="selected">${option}</option>`;
      }
      selectElement.append(singleElement);
    });
  };

  const handlePrice = (product) => {
    const pricesElements = $(".custom-configurator-price");
    const price = (Math.round(product.price) / 100).toFixed(2);
    const totalPriceModal = $('.custom-configurator-total-price');
    pricesElements.html(`$${price}`);
    totalPriceModal.html(price);
  };

  const renderOrderSummary = () => {
    const orderDetailsComponent = $("#custom-configurator-order-details");
    var selectedFabric = $("[data-custom-configurator-fabric]").text();
    var selectedMount = $("[data-custom-configurator-mount]").text();
    var selectedLift = $("[data-custom-configurator-lift]").text();
    var selectedRoll = $("[data-custom-configurator-roll]").text();
    var selectedCassette = $("[data-custom-configurator-cassette]").text();
    const selectedMountModal = $('.custom-configurator-mount');
    const selectedLiftModal = $('.custom-configurator-lift');
    const selectedWidthModal = $('.custom-configurator-width');
    const selectedLengthModal = $('.custom-configurator-length');
    const selectedRollerModal = $('.custom-configurator-roll');
    const selectedCassetteModal = $('.custom-configurator-cassette');
    const selectedFabricModal = $('.custom-configurator-color');

    orderDetailsComponent.find(".order-detail__fabric").html(selectedFabric);
    orderDetailsComponent.find(".order-detail__mount").html(selectedMount);
    orderDetailsComponent
      .find(".order-detail__width")
      .html(`${widthValue}" ${selectWidthSub.val()}`);
    orderDetailsComponent
      .find(".order-detail__length")
      .html(`${lengthValue}" ${selectLengthSub.val()}`);
    orderDetailsComponent.find(".order-detail__lift").html(selectedLift);
    orderDetailsComponent.find(".order-detail__roll").html(selectedRoll);
    orderDetailsComponent
      .find(".order-detail__cassette")
      .html(selectedCassette);

    selectedMountModal.html(selectedMount);
    selectedLiftModal.html(selectedLift);
    selectedWidthModal.html(`${widthValue}" ${selectWidthSub.val()}"`);
    selectedLengthModal.html(`${lengthValue}" ${selectLengthSub.val()}"`);
    selectedRollerModal.html(selectedRoll);
    selectedCassetteModal.html(selectedCassette);
    selectedFabricModal.html(selectedFabric);
  };

  // Available options
  const availableWidths = getAvailableWidths(fullData).widthArray;
  const selectableWidths = getAvailableWidths(fullData).fullWidthArray;
  const availableLengths = getAvailableLengths(
    fullData[0].variants
  ).lengthArray;
  const selectableLengths = getAvailableLengths(
    fullData[0].variants
  ).fullLengthArray;

  createSelectOptions(selectableWidths, "select-width-id");
  createSelectOptions(selectableLengths, "select-length-id");

  const selectElements = $(".option-selector");
  const sizeValueText = $("#custom-configurator-option-title-value-size");
  const selectWidthSub = $("#select-sub-width-id");
  const selectLengthSub = $("#select-sub-length-id");

  selectElements.each((_, element) => {
    if (_ == 0) {
      widthValue = $("#select-width-id").val();
      lengthValue = $("#select-length-id").val();
      sizeValueText.html(
        `${widthValue}" ${selectWidthSub.val()} W X ${lengthValue}" ${selectLengthSub.val()} L`
      );
      const cassetteValue = $("#js-cassette-value-id").attr(
        "data-image-select-value"
      );
      const productToAdd = getProductByOptions(
        fullData,
        widthValue,
        availableWidths,
        lengthValue,
        availableLengths,
        cassetteValue
      );
      handlePrice(productToAdd);
      renderOrderSummary();
    }
    $(element).change(() => {
      widthValue = $("#select-width-id").val();
      lengthValue = $("#select-length-id").val();

      if (parseInt(widthValue) >= 26) {
        $("#custom-configurator-image-select-item-cordless").show();
      } else {
        const liftSelector = $("#custom-configurator-option-lift");
        $("#custom-configurator-image-select-item-cordless").hide();
        $("#custom-configurator-image-select-item-cordless").removeClass(
          "custom-configurator-image-select-item-active"
        );
        liftSelector.attr(
          "data-image-select-value",
          "Stainless Steel Continuous Loop (Left)"
        );
        liftSelector
          .prev()
          .children(".custom-configurator-option-title-value")
          .html("Stainless Steel Continuous Loop (Left)");
        liftSelector
          .children(".custom-configurator-image-select-item")
          .each(function (_, el) {
            $(el).removeClass("custom-configurator-image-select-item-active");
            if (_ == 0) {
              $(el).addClass("custom-configurator-image-select-item-active");
            }
          });
      }

      sizeValueText.html(
        `${widthValue}" ${selectWidthSub.val()} W X ${lengthValue}" ${selectLengthSub.val()} L`
      );
      const cassetteValue = $("#js-cassette-value-id").attr(
        "data-image-select-value"
      );
      const productToAdd = getProductByOptions(
        fullData,
        widthValue,
        availableWidths,
        lengthValue,
        availableLengths,
        cassetteValue
      );
      handlePrice(productToAdd);
      renderOrderSummary();
    });
  });

  // Setting up slider
  $(document).ready(function () {
    $(".custom-configurator-gallery-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
    });

    $("#slick-configurator-next").click(function () {
      $(".custom-configurator-gallery-slider").slick("slickNext");
    });

    $("#slick-configurator-prev").click(function () {
      $(".custom-configurator-gallery-slider").slick("slickPrev");
    });
  });

  // Setting up custom image select
  const collectionImageComponent = $("#custom-configurator-collection-image");
  const shaderImageComponent = $("#custom-configurator-shader");
  const customGalleryShaderElement = $(
    "#js-configurator-custom-gallery-shader"
  );
  const imageSelectorElements = $(".custom-configurator-image-select");
  const fabricElements = $(".js-custom-configurator-fabric");
  const rollElements = $(".js-custom-configurator-rolls");
  const cassetteSelectors = $(".js-custom-cassette-selector");

  const cassettesButtons = $("#js-cassette-value-id").children();

  const mountSelectables = $(".js-custom-configurator-mount");

  imageSelectorElements.each(function (_, imgSelectorEl) {
    const imageSelectsItems = $(imgSelectorEl).children(
      ".custom-configurator-image-select-item"
    );
    imageSelectsItems.each(function (__, imgSelectorItemEl) {
      $(imgSelectorItemEl).click(function () {
        imageSelectsItems.each(function (___, el) {
          $(el).removeClass("custom-configurator-image-select-item-active");
        });
        $(this).addClass("custom-configurator-image-select-item-active");
        const valueSelected = $(this).attr("data-image-select-item");
        $(this).parent().attr("data-image-select-value", valueSelected);
        $(this)
          .parent()
          .prev()
          .children(".custom-configurator-option-title-value")
          .html(valueSelected);
        const cassetteValue = $("#js-cassette-value-id").attr(
          "data-image-select-value"
        );
        const productToAdd = getProductByOptions(
          fullData,
          widthValue,
          availableWidths,
          lengthValue,
          availableLengths,
          cassetteValue
        );
        handlePrice(productToAdd);
        renderOrderSummary();
      });
    });
  });

  // fabricElements.each(function (_, fabricElement) {
  //   $(fabricElement).click(function () {
  //     const fabricElementImg = $(this).children("img")[0];
  //     const imageSrc = $(fabricElementImg).attr("src");
  //     customGalleryShaderElement.attr("src", imageSrc);
  //     collectionImageComponent.fadeOut(300);
  //     shaderImageComponent.fadeIn(300);
  //   });
  // });

  rollElements.each(function (_, rollElement) {
    $(rollElement).click(function () {
      let valueSelected = $(this).attr("data-image-select-item");
      if (valueSelected == "Reverse (No Cassette Available)") {
        cassetteSelectors.hide();
        $("#js-cassette-value-id").attr("data-image-select-value", "None");
        $("#custom-configurator-option-title-value-cassette").html("None");
        $("#js-cassette-value-id")
          .children()
          .each(function (_, el) {
            $(el).removeClass("custom-configurator-image-select-item-active");
          });
        $($("#js-cassette-value-id").children()[0]).addClass(
          "custom-configurator-image-select-item-active"
        );
      } else {
        cassetteSelectors.show();
      }
    });
  });

  cassettesButtons.each(function (_, cassetteButton) {
    $(cassetteButton).click(function () {
      const cassetteValue = $("#js-cassette-value-id").attr(
        "data-image-select-value"
      );
      const productToAdd = getProductByOptions(
        fullData,
        widthValue,
        availableWidths,
        lengthValue,
        availableLengths,
        cassetteValue
      );
      handlePrice(productToAdd);
      renderOrderSummary();
    });
  });

  mountSelectables.each(function (_, mountButton) {
    $(mountButton).click(function () {
      const mountButtonValue = $(this).attr("data-image-select-item");
      if (mountButtonValue == "Mount Outside") {
        $("#js-outside-mount-info").show();
        $("#js-inside-mount-info").hide();
        $("#js-outside-mount-size-info").show();
        $("#js-inside-mount-size-info").hide();
      } else {
        $("#js-outside-mount-info").hide();
        $("#js-inside-mount-info").show();
        $("#js-outside-mount-size-info").hide();
        $("#js-inside-mount-size-info").show();
      }
    });
  });

  // Other

  const nextStepBtn = $("#custom-configurator-next-step");
  const nextStepComponent = $("#custom-configurator-next-step-component");
  const swatchInfoBtn = $("#custom-configurator-swatch-info");
  const swatchInfoCloseBtn = $("#custom-configurator-swatch-info-close");
  const swatchInfoModal = $("#custom-configurator-swatch-info-modal");
  const swatchInfoModalComponent = $(
    "#custom-configurator-swatch-info-modal-wrapper"
  );
  const orderDetailsBtn = $("#custom-configurator-expand-order-details");
  const orderDetailsComponent = $("#custom-configurator-order-details");

  nextStepBtn.click(function () {
    var topY = nextStepComponent.offset().top - 100;
    window.scroll(0, topY);
  });

  swatchInfoBtn.click(function () {
    swatchInfoModalComponent.fadeIn(300);
  });

  swatchInfoCloseBtn.click(function () {
    swatchInfoModalComponent.fadeOut(300);
  });

  swatchInfoModalComponent.click(function (e) {
    if (!$(e.target).is(swatchInfoModal)) {
      $(this).fadeOut();
    }
  });

  orderDetailsBtn.click(function () {
    orderDetailsComponent.fadeIn();
  });

  // Cart

  const quantityInput = $("#custom-configurator-collection-qty-value");
  const quantityAdd = $("#custom-configurator-collection-qty-btn-increase");
  const quantityReduce = $("#custom-configurator-collection-qty-btn-reduce");
  const quantityOptionPlus = $("[data-configurator-qty-option-plus]");
  let quantityValueModal = $('.custom-configurator-qty');

  quantityOptionPlus.click(function () {
    $("#custom-configurator-collection-qty-popout").addClass(
      "popout-container--alt"
    );
  });

  quantityValueModal.html(quantityInput.val());

  let currentValue = parseInt(quantityInput.val());
  quantityInput.change(function () {
    const quantityValue = $(this).val();
    if (quantityValue < 1) {
      $(this).val(1);
    }
    currentValue = parseInt(quantityInput.val());
    quantityValueModal.html(currentValue);
    updateSubtotal(currentValue);
  });

  const updateSubtotal = (qty) => {
    const productPrice = $('.single-price').text().slice(1);
    const totalPrice = productPrice * qty;
    $('.total-price').text(`$ ${totalPrice.toFixed(2)}`);

    const totalPriceModal = $('.custom-configurator-total-price');
    totalPriceModal.html(totalPrice.toFixed(2));
  }

  quantityAdd.click(function () {
    currentValue++;
    quantityInput.val(currentValue);
    updateSubtotal(currentValue);
  });

  quantityReduce.click(function () {
    if (quantityInput.val() <= 1) {
      quantityInput.val(1);
    } else {
      currentValue--;
      quantityInput.val(currentValue);
      updateSubtotal(currentValue);
    }
  });

  const customConfiguratorAddToCart = $(
    "#custom-configurator-collection-submit"
  );

  customConfiguratorAddToCart.click(function () {
    customConfiguratorAddToCart.addClass("is-loading");
    const cassetteValue = $("#js-cassette-value-id").attr(
      "data-image-select-value"
    );
    const productToAdd = getProductByOptions(
      fullData,
      widthValue,
      availableWidths,
      lengthValue,
      availableLengths,
      cassetteValue
    );
    let properties = {};

    $(".custom-configurator-image-select").each(function (_, el) {
      let elName = $(el).attr("data-image-select-name");
      let elValue = $(el).attr("data-image-select-value");
      properties[elName] = elValue;
    });

    properties[
      "size"
    ] = `${widthValue}" ${selectWidthSub.val()} W X ${lengthValue}" ${selectLengthSub.val()} L`;
    properties["Length"] = `${lengthValue}" ${selectLengthSub.val()}`;
    properties["Width"] = `${widthValue}" ${selectWidthSub.val()}`;
    const WindowDescription = $("#window-description").val();
    properties["Window Description"] = WindowDescription;

    let formData = {
      items: [
        {
          id: productToAdd.id,
          quantity: parseInt(quantityInput.val()),
          properties,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        initCartEvent();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    closeModal();
  });

  const initCartEvent = () => {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:cart:init", {
        bubbles: true,
        detail: {
          button: customConfiguratorAddToCart,
        },
      })
    );
  };

  const configuratorSubmit = $('#custom-configurator-collection-submit');
  $('input[type="checkbox"]').change(function () {
    if (this.checked) {
      configuratorSubmit.removeClass('variant--unavailable');
      configuratorSubmit.prop("disabled", false);

    } else {
      configuratorSubmit.addClass('variant--unavailable');
      configuratorSubmit.prop("disabled", true);
    }
  });

  const closeModal = () => {
    setTimeout(() => {
      $('.product-modal').css({
        'opacity': '0',
        'display': 'none'
      });
    }, 1000);
  };
})();